/**
 * AppealSlice Edit Tracking Reducers
 * 
 * Reducers for tracking edit state and unsaved changes.
 */

import { CaseReducer } from '@reduxjs/toolkit';
import { AppealSliceState } from '../state';

// =============================================================================
// EDIT TRACKING REDUCERS
// =============================================================================

/**
 * Mark the appeal as having unsaved changes
 */
export const markAsChanged: CaseReducer<AppealSliceState> = (state) => {
  state.hasUnsavedChanges = true;
};

/**
 * Mark the appeal as saved (clear unsaved changes flag)
 */
export const markAsSaved: CaseReducer<AppealSliceState> = (state) => {
  state.hasUnsavedChanges = false;
};

/**
 * Discard changes (clear unsaved changes flag without saving)
 */
export const discardChanges: CaseReducer<AppealSliceState> = (state) => {
  state.hasUnsavedChanges = false;
};
